import reducer from "./reducers";

import * as processesActions from "./actions";

export { processesActions };

export default reducer;
